import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const ThemeSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ThemeSettingsPage" */ "@circle-react/components/SettingsApp/CustomizeCommunity"
    ),
);

export const ThemeSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <ThemeSettingsComponent />
  </Suspense>
);
